import { forwardRef } from 'react';
import {
  DropdownSelectedValueStyles,
  mapSizeToTypographyVariant,
} from '../variants.style';
import { StatusIcon } from '../../../atoms/statusIcon/statusIcon';
import { StatusIconStylesVariants } from '../../../atoms/statusIcon/variants';
import { Typography } from '../../../ui';

type Props = {
  label: string;
  status: {
    color: StatusIconStylesVariants['color'];
    variant: StatusIconStylesVariants['variant'];
  };
  className?: string;
} & DropdownSelectedValueStyles;

export const DropdownSelectedStatusValue = forwardRef<HTMLDivElement, Props>(
  ({ label, status, size }, ref) => {
    return (
      <div className="flex flex-row items-center space-x-8" ref={ref}>
        <StatusIcon {...status} />

        <Typography
          variant={mapSizeToTypographyVariant(size)}
          weight="regular"
          className="flex-1 text-grayscale600"
        >
          {label}
        </Typography>
      </div>
    );
  },
);

DropdownSelectedStatusValue.displayName = 'DropdownSelectedStatusValue';
